import styled from 'styled-components';

import { Subtitle2 } from '@estee/elc-typography';
import { ContentSpacing } from '@estee/elc-base-theme';

export const Container = styled.div`
    width: 100%;
    margin-top: ${ContentSpacing.space10};
    padding: ${ContentSpacing.space16};
    border: 1px solid;
`;

export const PriceWrapper = styled.div`
    display: flex;
    margin-block-end: ${ContentSpacing.space12};
    .elc-cart-item-price-wrapper {
        display: inline-flex;
        align-items: normal;
        margin-inline: auto 0;
    }
`;

export const Label = styled(Subtitle2)`
    &.elc-cart-item-engrave-label::after {
        content: '\\002D';
        margin: 0 ${ContentSpacing.space2};
    }
    &.elc-cart-item-engrave-position::after {
        content: '\\003A';
        margin-inline-end: ${ContentSpacing.space8};
    }
`;

export const EngravingEdit = styled.span`
    margin-inline-end: ${ContentSpacing.space8};
    &::before {
        content: '\\007C';
        margin: 0 10px;
    }
`;
export const EngravingEditIcon = styled.span`
    &::after {
        content: '';
        display: inline-block;
        vertical-align: middle;
    }
`;
export const StyledButton = styled.button`
    margin: 0;
    border: unset;
    height: unset;
    text-align: left;
    background: unset;
    width: fit-content;
    padding: ${ContentSpacing.space6};
`;

export const StyledButtonBorder = styled(StyledButton)`
    border-right: 1px solid;
`;

export const EngravingDisclaimer = styled(Subtitle2)`
    text-align: justify;
    text-justify: inter-word;
    margin-block-start: ${ContentSpacing.space16};
`;
